import React from 'react';

export default function CareerCardWrapper({ children }) {
  return (
    <div className="grid grid-cols-1 gap-4 mx-auto md:grid-cols-2">
      {children}
    </div>
  );
}
